/*
 * Katana — Shopify Forms embed reskin.
 * The Shopify Forms app (e.g. the careers application form) renders inside an
 * open shadow DOM, so theme CSS can't reach it. This injects a <style> into the
 * embed's shadow root(s) to fit the dark Katana theme: transparent inputs with
 * white text, brand serif type, and the site's standard white .k-btn submit.
 * The .k-btn tokens inherit through the shadow boundary, so the button stays in
 * step with katana-tokens.css.
 * (The robust place to theme this remains the Shopify Forms app editor; this is
 * a best-effort so it matches the site without app-side changes.)
 */
(function () {
  'use strict';

  var CSS = [
    ':host, :host * { font-family: var(--k-font-body) !important; }',
    ':host { color: #ffffff; }',
    'input:not([type=checkbox]):not([type=radio]):not([type=file]), textarea, select {',
    '  background-color: transparent !important;',
    '  color: #ffffff !important;',
    '  border-color: rgba(255,255,255,0.28) !important;',
    '}',
    'input::placeholder, textarea::placeholder { color: rgba(255,255,255,0.4) !important; }',
    'label, legend, h1, h2, h3, h4, h5, p, span, li { color: #ffffff !important; }',
    /* The standard white action button (.k-btn), so form CTAs match the rest of
       the site. Sized to its label and centred rather than stretched. */
    'button[type=submit] {',
    '  box-sizing: border-box !important;',
    '  align-self: center !important;',
    '  width: auto !important;',
    '  min-width: 280px !important;',
    '  max-width: 100% !important;',
    '  justify-content: center !important;',
    '  padding: var(--k-btn-pad-y, 16px) var(--k-btn-pad-x, 46px) !important;',
    '  border: 0 !important;',
    '  border-radius: var(--k-btn-radius, 12px) !important;',
    '  background: #ffffff !important;',
    '  color: var(--k-black, #000) !important;',
    '  font-size: var(--text-sm, 14px) !important;',
    '  letter-spacing: var(--tracking-wide, 0.18em) !important;',
    '  text-transform: uppercase !important;',
    '  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.45), 0 0 18px rgba(255, 255, 255, 0.35) !important;',
    '  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease !important;',
    '}',
    'button[type=submit]:hover {',
    '  transform: translateY(-2px);',
    '  filter: brightness(1.08);',
    '  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.55), 0 0 28px rgba(255, 255, 255, 0.5) !important;',
    '}',
    'button[type=submit]:active {',
    '  transform: translateY(0);',
    '  filter: brightness(0.82);',
    '  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.4) !important;',
    '}'
  ].join('\n');

  function injectInto(shadow) {
    if (!shadow || shadow.querySelector('style[data-katana-forms]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-katana-forms', '');
    style.textContent = CSS;
    shadow.appendChild(style);
  }

  function walk(node) {
    if (!node) return;
    if (node.shadowRoot) {
      injectInto(node.shadowRoot);
      node.shadowRoot.querySelectorAll('*').forEach(walk);
    }
  }

  function run() {
    document.querySelectorAll('shopify-forms-embed, [class*="shopify-forms"]').forEach(walk);
  }

  var tries = 0;
  var iv = setInterval(function () {
    tries += 1;
    run();
    if (tries > 40) clearInterval(iv);
  }, 500);

  run();
})();
